export default "__VITE_ASSET__DSkHeNN9__"